<div class="vsp container">
   <div class="d-flex justify-content-between align-items-center vsp-header">
      <div
         class="vsp-header-left"
         *ngIf="service.week()">
         <h3>
            {{ service.week().practiceName }}
         </h3>
         <div style="width: 0px; height: 0px; overflow: hidden">
            <p-datePicker
               #pckr
               appendTo="body"
               [ngModel]="weekStartDate()"
               [showIcon]="true"
               dateFormat="yy-mm-dd"
               (onSelect)="onWeekStartChange($event)"></p-datePicker>
         </div>
         <h6
            #pckrToggle
            (click)="pckr.toggle()"
            style="cursor: pointer">
            Week of {{ weekStart() | date: "MMMM d, yyyy" }}
            <i class="fa fa-chevron-down"></i>
         </h6>
      </div>
      <div
         class="align-items-center vsp-header-right"
         [ngClass]="{ 'd-flex': !!service.week(), 'w-100': !service.week() }">
         <button
            *ngIf="isAdmin() && service.week()"
            class="v-button v-button-md v-green ml-3 mr-1"
            (click)="exportAllPractices()">
            <i class="fa fa-file-export"></i>
            &nbsp;&nbsp;Export All Practices
         </button>
         <button
            *ngIf="isAdmin() && service.week()"
            class="v-button v-button-md v-green ml-3 mr-1"
            (click)="exportWeeklyHours()">
            <i class="fa fa-file-export"></i>
            &nbsp;&nbsp;Weekly Hours Report
         </button>
         <vc-practice-select
            [autoselect]="false"
            urlBase="/vet-schedule-planner"></vc-practice-select>
         <p-menu
            #menu
            [model]="copyWeekItems()"
            [popup]="true" />

         <button
            class="v-button v-button-md v-green m-1 copy-drop-button"
            *ngIf="!!service.week()"
            [disabled]="!service.week().id"
            (click)="menu.toggle($event)">
            <i class="fa-solid fa-copy"></i>
            &nbsp;&nbsp;Copy Week
            <span class="copy-drop-arrow">
               <i class="fa-solid fa-chevron-down"></i>
            </span>
         </button>
         @if (service.isPrevWeek()) {
            <button
               class="v-button v-button-md v-darkgreen m-1"
               (click)="confirmWeek()"
               *ngIf="!!service.week()"
               [disabled]="!service.isReadyToConfirm()">
               Confirm Week
            </button>
         }
         <button
            class="v-button v-button-md v-darkgreen m-1"
            (click)="submitWeek()"
            *ngIf="!!service.week() && service.week().status == VSPWeek_Status.Incomplete"
            [disabled]="!service.isReadyToSubmit()">
            Submit Week
         </button>
         <button
            class="v-button v-button-md v-gold m-1"
            (click)="unsubmitWeek()"
            *ngIf="!!service.week() && service.week().status == VSPWeek_Status.Submitted">
            Unsubmit Week
         </button>
         <div
            *ngIf="service.week()"
            class="vsp-instructions">
            Complete all empty doctor shifts in order to activate the "Submit Week" button.
            <br />
            Click "Unsubmit Week" button to edit submitted shifts or add new doctors.
         </div>
      </div>
   </div>
   <div
      *ngIf="service.week()"
      class="row">
      <div class="col-auto fixed-column date-select-column">
         <p-listbox
            class="vsp-list"
            [options]="service.weekList()"
            [(ngModel)]="service.selectedWeekInfo"
            optionLabel="firstDay"
            fluid
            (onChange)="onListboxWeekChange($event)"
            scrollHeight="calc(100vh - 280px)">
            <!--<ng-template pTemplate="header">
               <a
			      href="javascript:void(0);"
			      class="prev-week-link">
				     <i class="fa fa-angle-double-left"></i>Previous Week
			   </a>
            </ng-template>-->
            <ng-template
               let-week
               pTemplate="item">
               <div
                  class="vsp-weeklist-date"
                  [ngClass]="{ 'vsp-selected-date': week.firstDay?.substring(0, 10) === weekStart() }"
                  [attr.data-selected]="week.firstDay?.substring(0, 10) === weekStart()">
                  <i
                     *ngIf="week.status == VSPWeek_Status.Incomplete"
                     class="fa-solid fa-circle-exclamation vsp-yellow"></i>
                  <i
                     *ngIf="week.status == VSPWeek_Status.Submitted"
                     class="fa-regular fa-circle-check vsp-green"></i>
                  <i
                     *ngIf="week.status == VSPWeek_Status.Confirmed"
                     class="fa-solid fa-check-double vsp-green"></i>
                  <span class="vsp-date-range">{{ week.startEndString }}</span>
               </div>
            </ng-template>
         </p-listbox>
      </div>

      <div class="col-md pl-2 vsp-calendar-week">
         <div class="top-of-calendar">
            <span class="week-instructions">Click "Closed" on the day of the week to close all shifts in the day.</span>
            <span class="print-section">
               <button
                  (click)="printWeek()"
                  class="v-button v-button-sm v-black">
                  <i class="fa fa-print"></i>
                  &nbsp;&nbsp;Print Week
               </button>
            </span>
         </div>

         <p-table
            class="vsp-table"
            [value]="service.week().doctors"
            showGridlines
            size="small"
            [scrollable]="true"
            scrollHeight="calc(100vh - 330px)">
            <ng-template #header>
               <tr style="height: 65px">
                  <th class="vsp-header-name">
                     <!--<span>Name</span>-->
                  </th>
                  @for (day of service.weekdays; track day; let i = $index) {
                     <th
                        (clickasd)="service.setWeekdayClosed(i, !service.week().isDayClosed[i])"
                        class="vsp-header-day">
                        <span class="text-start">
                           {{ day }}
                           <br />
                           @if (service.officeHours()?.hours?.[i]) {
                              <div class="vsp-office-hours">{{ service.officeHours().hours[i] }}</div>
                           }
                           <div class="vsp-weekly-date">{{ datefns.format(datefns.addDays(service.week().firstDay, i), "MM/dd") }}</div>
                        </span>
                        <vc-checkbox
                           [disabled]="service.week()?.status > 1"
                           label="Closed?"
                           [inputId]="'isclosed-' + i"
                           [ngModel]="service.week().isDayClosed[i]"
                           class="day-is-closed"
                           (ngModelChange)="service.setWeekdayClosed(i, !service.week().isDayClosed[i])"></vc-checkbox>
                     </th>
                  }
                  <th style="width: 5rem; line-height: 17px">Total hours</th>
                  <th style="width: 5rem; line-height: 17px">Doctor days</th>
               </tr>
            </ng-template>
            <ng-template
               #body
               let-doctor
               let-i="rowIndex">
               <tr style="height: 100px">
                  <td class="vsp-user-column">
                     {{ doctor.firstName }} {{ doctor.lastName }}
                     <div class="vsp-user-type">
                        {{ doctorTypes[doctor.type] }}
                        <span *ngIf="!!doctor.payClass">- {{ doctor.payClass }}</span>
                        <span *ngIf="doctor.normalWeeklyHours != null">- {{ doctor.normalWeeklyHours | number: "1.0-2" }} hrs/wk</span>
                     </div>

                     <div class="d-flex align-items-center justify-content-between">
                        <vc-checkbox
                           [disabled]="service.week()?.status > 1"
                           label="Entire week off?"
                           [inputId]="'allWeekOff-' + i"
                           [ngModel]="service.isDoctorAllWeekOff()[i]"
                           class="doctor-is-off"
                           (ngModelChange)="
                              service.markDoctorAllWeek(doctor, service.isDoctorAllWeekOff()[i] ? VSPDay_Type.NotSet : VSPDay_Type.ScheduledDayOff)
                           "></vc-checkbox>
                        <!-- <button
                           class="v-button v-button-sm v-red-border vsp-user-button"
                           (click)="service.markDoctorAllWeek(doctor, VSPDay_Type.ScheduledDayOff)">
                           Mark the entire week off
                        </button> -->
                        <button
                           class="v-button v-button-sm v-gray-border vsp-user-button"
                           (click)="service.showDoctorInfoDialog(doctor)">
                           View info
                        </button>
                     </div>
                  </td>
                  @for (day of doctor.days; track day.weekday) {
                     <td style="height: 1px">
                        <vsp-table-cell
                           [day]="day"
                           [doctor]="doctor"></vsp-table-cell>
                     </td>
                  }
                  <td class="vsp-total-hours">{{ service.doctorTotals()[i] | number: "1.0-2" }}</td>
                  <td class="vsp-total-hours">{{ service.doctorDays()[i] }}</td>
               </tr>
            </ng-template>
            <ng-template #footer>
               <tr>
                  <td><strong>Totals</strong></td>
                  @for (day of service.weekdays; track day; let dayIndex = $index) {
                     <td>
                        <strong>
                           {{ service.dayTotals()[dayIndex] || 0 | number: "1.0-2" }}
                        </strong>
                     </td>
                  }
                  <td></td>
                  <td></td>
               </tr>
            </ng-template>
         </p-table>

         <div
            class="mt-3 mb-3"
            *ngIf="!!service.week()">
            <button
               [disabled]="service.week()?.status > 1"
               class="v-button v-button-md v-green-border m-1"
               (click)="service.showAddDoctorDialog()">
               <i class="fa fa-user-plus"></i>
               Add doctor
            </button>
            <button
               [disabled]="service.week()?.status > 1"
               class="v-button v-button-md v-green m-1"
               (click)="service.showInactiveDoctorList()">
               List of inactive doctors
            </button>
         </div>

         <vsp-day-dialog></vsp-day-dialog>
         <vsp-add-doctor-dialog></vsp-add-doctor-dialog>
         <vsp-doctor-info-dialog></vsp-doctor-info-dialog>
         <vsp-inactive-doctor-list-dialog></vsp-inactive-doctor-list-dialog>
         <p-confirmDialog
            header="Confirmation"
            icon="pi pi-exclamation-triangle"></p-confirmDialog>

         <p-blockui
            styleClass="vsp"
            [blocked]="service.isLoading()">
            <vc-spinner [loading]="true"></vc-spinner>
         </p-blockui>
      </div>
   </div>
</div>
